module.exports = __webpack_public_path__ + "img/沈尚宏.89f6c0ea.jpg";